/**
 * Enum Theo dõi
 * dmha 12.03.2024
 */
export default {
  NotSet: 1, // chưa thiết lập
  IsSetting: 2, // đang thiết lập
  AwaitEnact: 3, // chờ ban hành
  Enacted: 4, // đã ban hành
};
